import React from "react";
import { HomeCarousel } from "./HomeCarousel";

export const HomeContent = () => {
  return (
    <div className="bg-white w-full font-inter">
      <HomeCarousel />
    </div>
  );
};

export default HomeContent;
